export class ModuleMaterial {
    id?: number;
    name?: string;
    filename?: string;
    mime?: string;

    static fromJson(fields: any): ModuleMaterial {
        let item = Object.assign(new this(), fields);
        return item
    }
}
